import successIcon from "assets/img/icons/success-green-big.svg";
import { useRefreshItems } from "hooks/useRefreshItems";

const CancelListingSuccess = ({ closeWindow }) => {
  const refresh = useRefreshItems();
  return (
    <>
      <header className="modal-window__header">
        <img src={successIcon} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">Success!</h5>
        <p className="modal-window__info">Your card listing is cancelled.</p>
      </header>
      <footer className="modal-window__footer">
        <button
          className="modal-window__footer-submit"
          onClick={() => {
            closeWindow();
            refresh();
            window.scrollTo(0, 0);
          }}
        >
          Done
        </button>
      </footer>
    </>
  );
};

export default CancelListingSuccess;
